export default __webpack_public_path__ + "static/media/bg-pattern-small-circle.6998c69d.svg";